import { Color } from "three";
import { BasePanel } from "./BasePanel";
import VUtil from "../VUILib/VUtils.js";

const bg = "/assets/vrUI/common/bg.png";
const titleBgPath = "/assets/vrUI/common/titleBg.png";
const closeIconPath = "/assets/vrUI/common/close.png";
const openToggleIconPath = "/assets/vrUI/vrSettingPanel/open.png";
const closeToggleIconPath = "/assets/vrUI/vrSettingPanel/close.png";
const btn_normalPath = "/assets/vrUI/common/btn_normal.png";
const btn_hoverPath = "/assets/vrUI/common/btn_hover.png";
const btn_clickPath = "/assets/vrUI/common/btn_click.png";
const confirmIconPath = "/assets/vrUI/vrSettingPanel/confirmIcon.png";
const clearIconPath = "/assets/vrUI/vrSettingPanel/clearIcon.png";
const sliderBgPath = "/assets/vrUI/skyPanel/sliderBg1.png";
const sliderHandlePath = "/assets/vrUI/skyPanel/sliderHandle.png";

export class VRSettingPanel extends BasePanel {
  constructor(manager, visible) {
    super(manager, visible);
  }

  async init() {
    const width = 1;
    const height = 1.2;

    this.vrSettingMgr = this.manager.vrSettingManager;

    // container
    const bgMap = await this.manager.loadManager.loadTexture(bg);
    const container = this.uilib.createContainer({
      color: 0x0b0c0c,
      map: bgMap,
      opacity: 1,
      width: width,
      height: height,
      radius: 0.025,
      dragable: true,
    });
    this.uilib.addUIToScene(container);
    container.visible = this._visible;
    container.position.x -= 0.5;
    //container.scale.set(0.5, 0.5, 0.5);
    this.uiElements.push(container);

    // title
    const title = this.uilib.createText({
      text: "VR设置",
      textColor: 0xafbbe3,
      textSize: 0.05,
      font: "bold",
      align: "left",
    });
    container.add(title);
    title.position.y = height / 2 - 0.08;
    title.position.x = -width / 2 + 0.08;

    // close btn
    const closeIcon = await this.manager.loadManager.loadTexture(closeIconPath);
    const closeBtn = this.uilib.createBtn({
      map: closeIcon,
      text: "",
      color: "#A8B4DB",
      width: 0.1,
      height: 0.1,
      radius: 0,
    });
    closeBtn.addHoverEnterEvent((obj) => {
      obj.material.color = new Color("#6275B5");
    });
    closeBtn.addHoverExitEvent((obj) => {
      obj.material.color = new Color("#A8B4DB");
    });
    closeBtn.addClickEvent((obj) => {
      this.closePanel();
    });
    container.add(closeBtn);
    closeBtn.position.z = 0.001;
    closeBtn.position.y = height / 2 - 0.08;
    closeBtn.position.x = width / 2 - 0.11;

    // titleBg
    this.manager.loadManager.loadTexture(titleBgPath, (tex) => {
      const titleBg = this.uilib.createImage({
        map: tex,
        width: width * 0.9,
        height: 0.1,
        radius: 0,
      });
      container.add(titleBg);
      titleBg.position.y = height / 2 - 0.1;
    });

    const openToggleIcon = await this.manager.loadManager.loadTexture(
      openToggleIconPath
    );
    this.closeToggleIcon = await this.manager.loadManager.loadTexture(
      closeToggleIconPath
    );

    const btn_normal = await this.manager.loadManager.loadTexture(
      btn_normalPath
    );
    const btn_hover = await this.manager.loadManager.loadTexture(btn_hoverPath);
    const btn_click = await this.manager.loadManager.loadTexture(btn_clickPath);
    const confirmIcon = await this.manager.loadManager.loadTexture(
      confirmIconPath
    );
    const clearIcon = await this.manager.loadManager.loadTexture(clearIconPath);

    this.planeSettingElements = [];
    // 地板设置
    {
      const bg = this.uilib.createContainer({
        color: 0x8993c3,
        opacity: 0.3,
        width: width * 0.8,
        height: 0.4,
        radius: 0.05,
        dragable: false,
      });
      container.add(bg);
      bg.position.z = 0.001;
      bg.position.y = 0.2;

      // title
      {
        const floorSetting = this.uilib.createText({
          text: "地板设置",
          textColor: 0xafbbe3,
          textSize: 0.04,
          font: "bold",
          align: "left",
        });
        bg.add(floorSetting);
        floorSetting.position.z = 0.001;
        floorSetting.position.y = 0.125;
        floorSetting.position.x = -0.35;

        const btn = this.uilib.createBtn({
          map: this.vrSettingMgr.buttenKeys.PlaneKey
            ? openToggleIcon
            : this.closeToggleIcon,
          text: "",
          color: "#ffffff",
          width: 0.2,
          height: 0.08,
          radius: 0,
        });
        btn.addClickEvent((obj) => {
          // 关闭
          if (this.vrSettingMgr.buttenKeys.PlaneKey) {
            obj.material.map = this.closeToggleIcon;
            this.planeSettingElements.forEach((element) => {
              element.hide();
            });

            this.manager.interface.setClickMode(0); // 切换到默认模式
          }
          // 开启
          else {
            obj.material.map = openToggleIcon;
            this.planeSettingElements.forEach((element) => {
              element.show();
            });

            this.manager.interface.setClickMode(7); // 切换到地面编辑模式

            // 地板设置与位置设置互斥
            if (this.vrSettingMgr.buttenKeys.PositionKey) {
              this.positionBtn.material.map = this.closeToggleIcon;
              this.positionSettingElements.forEach((element) => {
                element.hide();
              });

              this.vrSettingMgr.BingerPostionSet(
                !this.vrSettingMgr.buttenKeys.PositionKey
              );
            }
          }

          //  调用 VRSettingManager 来切换
          this.vrSettingMgr.BingerPlaneSet(
            !this.vrSettingMgr.buttenKeys.PlaneKey
          );
        });
        bg.add(btn);
        btn.position.z = 0.001;
        btn.position.x = 0.25;
        btn.position.y = 0.125;

        this.planeBtn = btn;
      }

      // line
      const line = this.uilib.createContainer({
        color: 0xffffff,
        opacity: 1,
        width: width * 0.8,
        height: 0.001,
        radius: 0,
        dragable: false,
      });
      bg.add(line);
      line.renderOrder = 1000000;
      line.position.y = 0.05;

      // text 地板颜色
      {
        const floorColor = this.uilib.createText({
          text: "颜色",
          textColor: 0xafbbe3, //0xafbbe3,
          textSize: 0.04,
          font: "bold",
          align: "left",
        });
        bg.add(floorColor);
        floorColor.position.x = -0.3;
        floorColor.position.y = -0.025;

        // color picker
        const colorPicker = this.uilib.createColorPicker({
          width: 0.5,
          height: 0.5,
          radius: 0,
          iconWidth: 0.075,
          iconHeight: 0.075,
          needColorText: true,
          defaultColor: this.vrSettingMgr.VRPlaneColor,
          textColor: 0xafbbe3, //0xafbbe3,
        });
        colorPicker.addOnValueChangeEvent((color) => {
          this.vrSettingMgr.editorPlane("color", color);
        });
        bg.add(colorPicker);
        colorPicker.position.y = -0.025;
        colorPicker.position.x = 0;
        colorPicker.position.z = 0.002;

        this.planeSettingElements.push(floorColor, colorPicker);
      }

      // confirm btn
      {
        const confirmBtn = this.uilib.createBtn({
          map: btn_normal,
          text: "",
          width: 0.22,
          height: 0.08,
          radius: 0,
          stateChangeImage: {
            normal: btn_normal,
            hover: btn_hover,
            click: btn_click,
          },
        });
        confirmBtn.addHoverEnterEvent((obj) => {});
        confirmBtn.addHoverExitEvent((obj) => {});
        confirmBtn.addClickEvent((obj) => {
          this.vrSettingMgr.editorPlane("confirm");
          this.vrManager.makeSystemTip("地板确认成功");
        });
        bg.add(confirmBtn);
        confirmBtn.position.z = 0.001;
        confirmBtn.position.x = -0.15;
        confirmBtn.position.y = -0.125;

        const icon = this.uilib.createImage({
          renderOrder: 1000000,
          map: confirmIcon,
          width: 0.08,
          height: 0.08,
          radius: 0,
        });
        confirmBtn.add(icon);
        icon.position.x = -0.035;

        const text = this.uilib.createText({
          text: "确定",
          textColor: 0xafbbe3,
          textSize: 0.035,
          font: "bold",
          align: "center",
        });
        confirmBtn.add(text);
        text.position.x = 0.035;

        this.planeSettingElements.push(confirmBtn);
      }

      // clear btn
      {
        const clearBtn = this.uilib.createBtn({
          map: btn_normal,
          text: "",
          width: 0.22,
          height: 0.08,
          radius: 0,
          stateChangeImage: {
            normal: btn_normal,
            hover: btn_hover,
            click: btn_click,
          },
        });
        clearBtn.addHoverEnterEvent((obj) => {});
        clearBtn.addHoverExitEvent((obj) => {});
        clearBtn.addClickEvent((obj) => {
          this.vrSettingMgr.editorPlane("delect");
          this.vrManager.makeSystemTip("地板清除成功");
        });
        bg.add(clearBtn);
        clearBtn.position.z = 0.001;
        clearBtn.position.x = 0.15;
        clearBtn.position.y = -0.125;

        const icon = this.uilib.createImage({
          renderOrder: 1000000,
          map: clearIcon,
          width: 0.08,
          height: 0.08,
          radius: 0,
        });
        clearBtn.add(icon);
        icon.position.x = -0.035;

        const text = this.uilib.createText({
          text: "清空",
          textColor: 0xafbbe3,
          textSize: 0.035,
          font: "bold",
          align: "center",
        });
        clearBtn.add(text);
        text.position.x = 0.035;

        this.planeSettingElements.push(clearBtn);
      }

      if (!this.vrSettingMgr.buttenKeys.PlaneKey) {
        this.planeSettingElements.forEach((element) => {
          element.hide();
        });
      }
    }

    this.positionSettingElements = [];
    // 位置设置
    {
      const bg = this.uilib.createContainer({
        color: 0x8993c3,
        opacity: 0.3,
        width: width * 0.8,
        height: 0.3,
        radius: 0.05,
        dragable: false,
      });
      container.add(bg);
      bg.position.z = 0.001;
      bg.position.y = -0.2;

      // title
      {
        const positionSetting = this.uilib.createText({
          text: "位置设置",
          textColor: 0xafbbe3,
          textSize: 0.04,
          font: "bold",
          align: "left",
        });
        bg.add(positionSetting);
        positionSetting.position.z = 0.001;
        positionSetting.position.y = 0.075;
        positionSetting.position.x = -0.35;

        const btn = this.uilib.createBtn({
          map: this.vrSettingMgr.buttenKeys.PositionKey
            ? openToggleIcon
            : this.closeToggleIcon,
          text: "",
          color: "#ffffff",
          width: 0.2,
          height: 0.08,
          radius: 0,
        });
        btn.addClickEvent((obj) => {
          // 关闭
          if (this.vrSettingMgr.buttenKeys.PositionKey) {
            obj.material.map = this.closeToggleIcon;
            this.positionSettingElements.forEach((element) => {
              element.hide();
            });

            this.manager.interface.setClickMode(0); // 切换到默认模式
          }
          // 开启
          else {
            obj.material.map = openToggleIcon;
            this.positionSettingElements.forEach((element) => {
              element.show();
            });

            this.manager.interface.setClickMode(8); // 切换到位置设置模式

            // 地板设置与位置设置互斥
            if (this.vrSettingMgr.buttenKeys.PlaneKey) {
              this.planeBtn.material.map = this.closeToggleIcon;
              this.planeSettingElements.forEach((element) => {
                element.hide();
              });

              this.vrSettingMgr.BingerPlaneSet(
                !this.vrSettingMgr.buttenKeys.PlaneKey
              );
            }
          }

          //  调用 VRSettingManager 来切换
          this.vrSettingMgr.BingerPostionSet(
            !this.vrSettingMgr.buttenKeys.PositionKey
          );
        });
        bg.add(btn);
        btn.position.z = 0.001;
        btn.position.x = 0.25;
        btn.position.y = 0.075;
        this.positionBtn = btn;
      }

      // line
      const line = this.uilib.createContainer({
        color: 0xffffff,
        opacity: 1,
        width: width * 0.8,
        height: 0.001,
        radius: 0,
        dragable: false,
      });
      line.renderOrder = 1000000;
      bg.add(line);
      line.position.y = 0.0;

      // confirm btn
      {
        const confirmBtn = this.uilib.createBtn({
          map: btn_normal,
          text: "",
          width: 0.22,
          height: 0.08,
          radius: 0,
          stateChangeImage: {
            normal: btn_normal,
            hover: btn_hover,
            click: btn_click,
          },
        });
        confirmBtn.addHoverEnterEvent((obj) => {});
        confirmBtn.addHoverExitEvent((obj) => {});
        confirmBtn.addClickEvent((obj) => {
          this.vrSettingMgr.editorPostion("confirm");
          this.vrManager.makeSystemTip("位置确认成功");
        });
        bg.add(confirmBtn);
        confirmBtn.position.z = 0.001;
        confirmBtn.position.x = -0.15;
        confirmBtn.position.y = -0.075;

        const icon = this.uilib.createImage({
          map: confirmIcon,
          renderOrder: 1000000,
          width: 0.08,
          height: 0.08,
          radius: 0,
        });
        confirmBtn.add(icon);
        icon.position.x = -0.035;

        const text = this.uilib.createText({
          text: "确定",
          textColor: 0xafbbe3,
          textSize: 0.035,
          font: "bold",
          align: "center",
        });
        confirmBtn.add(text);
        text.position.x = 0.035;

        this.positionSettingElements.push(confirmBtn);
      }

      // clear btn
      {
        const clearBtn = this.uilib.createBtn({
          map: btn_normal,
          text: "",
          width: 0.22,
          height: 0.08,
          radius: 0,
          stateChangeImage: {
            normal: btn_normal,
            hover: btn_hover,
            click: btn_click,
          },
        });
        clearBtn.addHoverEnterEvent((obj) => {});
        clearBtn.addHoverExitEvent((obj) => {});
        clearBtn.addClickEvent((obj) => {
          this.vrSettingMgr.editorPostion("delect");
          this.vrManager.makeSystemTip("位置清除成功");
        });
        bg.add(clearBtn);
        clearBtn.position.z = 0.001;
        clearBtn.position.x = 0.15;
        clearBtn.position.y = -0.075;

        const icon = this.uilib.createImage({
          map: clearIcon,
          renderOrder: 1000000,
          width: 0.08,
          height: 0.08,
          radius: 0,
        });
        clearBtn.add(icon);
        icon.position.x = -0.035;

        const text = this.uilib.createText({
          text: "清空",
          textColor: 0xafbbe3,
          textSize: 0.035,
          font: "bold",
          align: "center",
        });
        clearBtn.add(text);
        text.position.x = 0.035;

        this.positionSettingElements.push(clearBtn);
      }

      if (!this.vrSettingMgr.buttenKeys.PositionKey) {
        this.positionSettingElements.forEach((element) => {
          element.hide();
        });
      }
    }

    // 调整UI距离的滑动条
    {
      const sliderBg = await this.manager.loadManager.loadTexture(sliderBgPath);
      const sliderHandle = await this.manager.loadManager.loadTexture(
        sliderHandlePath
      );

      const text1 = this.uilib.createText({
        text: "UI视距",
        textColor: 0xafbbe3, //0xafbbe3,
        textSize: 0.045,
        font: "bold",
        align: "left",
      });
      container.add(text1);
      text1.position.x = -width / 2 + 0.08;
      text1.position.y = -0.42;
      const slider1 = this.uilib.createSlider({
        map: sliderBg,
        color: 0xffffff,
        handleMap: sliderHandle,
        handleColor: 0xffffff,
        fillOpacity: 0,
        width: width * 0.75,
        height: 0.03,
        radius: 0.015,
      });
      slider1.setProgressValue((this.uilib.getCameraDis() + 1) / -2); // [-1 , -3]
      slider1.addOnValueChangeEvent((v) => {
        this.uilib.setCameraDis(-v * 2 - 1);
      });
      container.add(slider1);
      slider1.position.y = -0.5;
    }

    if (!this._visible) {
      this.hide();
    }
  }

  closePanel() {
    super.closePanel();

    // 关闭
    if (this.vrSettingMgr.buttenKeys.PlaneKey) {
      this.planeBtn.material.map = this.closeToggleIcon;
      this.planeSettingElements.forEach((element) => {
        element.hide();
      });

      //  调用 VRSettingManager 来切换
      this.vrSettingMgr.BingerPlaneSet(false);
    }

    // 关闭
    if (this.vrSettingMgr.buttenKeys.PositionKey) {
      this.positionBtn.material.map = this.closeToggleIcon;
      this.positionSettingElements.forEach((element) => {
        element.hide();
      });

      //  调用 VRSettingManager 来切换
      this.vrSettingMgr.BingerPostionSet(false);
    }

    this.manager.interface.setClickMode(0); // 切换到默认模式
  }
}
